export class VendorInfo {
  public GPVID: string;
  public VendorName: string;
  public AirportCode: string;
  public ContactName: string;
  public ContactTitle: string;
  public Address1: string;
  public Address2: string;
  public Address3: string;
  public City: string;
  public State: string;
  public Zip: string;
  public Country: string;
  public Phone1: string;
  public Mobile: string;
  public Fax: string;
  public Email: string;
  public Terms: string;
  public DateCreated: Date;
  public DateUpdated: Date;
  public AddressCode: string;
}



// WEBPACK FOOTER //
// ./src/app/models/VendorInfo.ts